<div class="component-powerbi-content">
  <iframe *ngFor="let single of data" [src]="single | safe" frameborder="0" onload="resizeIframe(this)"></iframe>
</div>
